import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListCities = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_CITIES'})
}

export const unmountDetailCities = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_CITIES'})
}

export const unmountMasterCities = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_CITIES'})
}

export const listCities = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_CITIES' })
  return API.GET('/city/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_CITIES_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_CITIES_FAILED' }), 
    ))
  })
}

export const detailCity = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_CITIES' })
  const params = {
    'id': id
  }
  API.GET('/city/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_CITIES_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_CITIES_FAILED' }), 
      ))
    )
  })
}

export const masterCities = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_CITIES' })
  return API.GET('/city/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_CITIES_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_CITIES_FAILED' }), 
    ))
  })
}

export const cityByProvince = (id, successCB, failedCB) => async (dispatch) => {
  const params = { 'id': id }
  API.GET('/city/getByProvinceId', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(err))
    )
  })
}

export const createCity = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/city/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editCity = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/city/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableCity = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/city/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableCity = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/city/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}